/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { getLang } from "../shared/GLang";
import { qreq } from "../shared/qrequest";
import BaseCom from "./BaseCom";
import Icon from "./Icon";
import Switch from "./Switch";

export default class FormInputV2 extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: '',
            options: null,
            searchResultList: null,
            selections: []
        };
    }

    async componentDidMount() {
        await this.loadOptions();
        this.setSearchDefaults();
    }
    
    componentDidUpdate(prevProps) {
        if(this.props.model !== prevProps.model) {
            if(this.state.options) {
                let options = [...this.state.options];
                this.setSelectedOptions(options);
                this.setState({ options });
            }
            this.setSearchDefaults();
        }
    }

    loadOptions = async () => {
        if(!this.props.api)
            return;
        try {
            let j = await qreq.getAsync(this.props.api);
            if (j.errorCode === 0) {
                this.setSelectedOptions(j.list);
                this.setState({ options: j.list });
                this.forceUpdate();
            }
            else {
                this.alert(j.errorMessage);
            }
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    setSelectedOptions = (options) => {
        let obj = this.props.model[this.props.name];
        if(!obj || !obj.length) return;
        obj.forEach(i => {
            var find = options.find(x => x.id === i.id);
            if(find)
                find.selected = true;
        });
    }

    change = (e) => {
        this.props.model[this.props.name] = e.target.value;
        this.forceUpdate();
        if(this.props.type === 'select' && this.props.useObjectValue) {
            let options = this.state.options || this.props.options;
            let find = options.find(x => x.id === parseInt(e.target.value));
            this.props.onChange?.(find);
        }
        else
            this.props.onChange?.(e.target.value);
    }

    toggle = (e) => {
        this.props.model[this.props.name] = e.target.checked;
        this.forceUpdate();
        this.props.onChange?.(e.target.checked);
    }
    
    toggleOption = (opt) => {
        let options = [...this.state.options];
        opt.selected = !opt.selected;
        let obj = options.filter(x => x.selected);
        this.props.model[this.props.name] = obj;
        this.forceUpdate();
        this.setState({ options: options });
        this.props.onChange?.(obj);
    }

    file = (e) => {
        for (let n = 0; n < e.target.files.length; n++) {
            var f = e.target.files[n];
            console.log('Uploading: ' + f.name);
            this.readFile(f);
        };
    }

    readFile = (f) => {
        var obj = { key: this.uuid(), progress: 0 };
        var reader = new FileReader();
        this.setState({ progress: 0 });
        reader.onload = () => {
            var b64data = btoa(reader.result);
            obj.base64Content = b64data;
            obj.fileType = f.type;
            obj.fileSize = f.size;
            obj.name = f.name;
            obj.file = f;
            obj.dataSrc = 'data:' + obj.fileType + ';base64,' + obj.base64Content;


            this.props.model[this.props.name] = obj.dataSrc;
            this.forceUpdate();
            this.props.onDataChange?.(obj);
        };
        reader.onerror = (error) => {
            console.log('Error: ', error);
        };
        reader.readAsBinaryString(f);
    }

    search = (e) => {
        e?.preventDefault();
        
        let data = { query: e.target.value };
        this.setState(data);

        if(!data.query) {
            this.setState({ searchResultList: null,  });
            return;
        }


        if(this.searchTimeout)
            clearTimeout(this.searchTimeout);
        this.searchTimeout = this.apiPostTimeout(this.props.searchUrl, data, 500, (j) => {
            if(!this.state.query)
                this.setState({ searchResultList: null });
            else if(j.list)
                this.setState({ searchResultList: j.list })
        });
    }

    select = (item) => {
        let selections = [...this.state.selections];

        if(!this.props.allowDuplicates) {
            if(selections.find(x => x.id === item.id)) {
                this.alert('Duplicates are not allowed.');
                return;
            }
        }

        selections.push(item);

        this.props.model[this.props.name] = selections;

        this.setState({ selections, searchResultList: null, query: '' });
        this.props.onChange?.(selections);
    }

    removeSelect = (item) => {
        let selections = [...this.state.selections];
        selections.splice(selections.indexOf(item), 1);
        this.setState({ selections });
        this.props.onChange?.(selections);
    }

    setSearchDefaults = () => {
        let list = this.props.model?.[this.props.name];
        if(!list || !list.length) return;
        this.setState({ selections: list });
    }

    render() {
        let options = this.state.options || this.props.options;
        if (this.props.type === 'switch') {
            
            return (
                <Switch model={this.props.model} name={this.props.name} label={this.props.label} />
            );
        }
        return (
            <div className="form-group">
                {this.props.label && <label className="form-label">{this.props.required ? '*' : ''} {getLang(this.props.label)}</label>}
                <div className={this.props.type === 'multi-search' ? '' : 'input-group'}>
                    {this.props.preInput ? <span className="input-group-text">{this.props.preInput}</span> : ''}
                    {

                    this.props.type === 'file' ? (
                        <div>
                            <input type="file" className="form-control" onChange={this.file} />
                        </div>
                    ) :
                    
                    
                    this.props.type === 'select' ? (
                        <select className="form-select" value={this.props.model?.[this.props.name] || ''} onChange={this.change} required={this.props.required}>
                            <option value="">
                                {getLang(
                                    (this.props.required ? '* ' : '')
                                    + (this.props.selectDefault ? this.props.selectDefault
                                        : 'Select ' + (this.props.label || this.props.placeholder || '')))}
                                </option>
                            {options?.map((i, idx) => <option key={idx} value={i.id}>{getLang(i.name)}</option>)}
                        </select>

                    ) :
                    
                    this.props.type === 'multi-select' ? (
                        <div className="list-group" style={{ maxHeight: '12.5rem', overflow: 'auto', width: '100%' }}>
                            {options?.map((i, idx) => <div key={idx} className={'list-group-item' + (i.selected ? ' active' : '')} onClick={() => this.toggleOption(i)}
                                                            role="button">
                                {getLang(i.name)} {i.selected && <Icon icon="faCheck" />}
                            </div>)}
                        </div>
                    ) :


                    this.props.type === 'multi-search' ? (

                        <>
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.query}
                                onChange={this.search}
                                placeholder={(this.props.placeholder ? (this.props.required ? '* ' : '') + this.props.placeholder : '')}
                                style={this.props.style} readOnly={this.props.readOnly} />

                            {this.state.searchResultList && <ul className="list-group">
                                {this.state.searchResultList.map((i, idx) => <li key={idx} className="list-group-item" role="button" onClick={() => this.select(i)}>
                                    {i.name}
                                </li>)}
                            </ul>}

                            <div className="d-flex gap-1 mt-3">
                                {this.state.selections?.map((i,idx) => <div key={idx} className="badge bg-primary p-2 fs-6">
                                    <span>{i.name}</span>
                                    <span className="ms-1" onClick={() => this.removeSelect(i)}><Icon icon="faTimes" /></span>
                                </div>)}
                            </div>
                        </>
                   
                    ) :
                    
                    this.props.type === 'textarea' ? (
                        <textarea className="form-control" value={this.props.model?.[this.props.name] || ''} onChange={this.change} placeholder={(this.props.placeholder ? (this.props.required ? '* ' : '') + this.props.placeholder : '')} required={this.props.required} style={this.props.style} readOnly={this.props.readOnly} />
                    )
                        :
                        (
                            <input type={this.props.type || 'text'} className="form-control" value={this.props.model?.[this.props.name] || ''} onChange={this.change} placeholder={(this.props.placeholder ? (this.props.required ? '* ' : '') + this.props.placeholder : '')} required={this.props.required} style={this.props.style} readOnly={this.props.readOnly} />
                        )}
                </div>
                {this.props.note && <p className="text-muted">{this.props.note}</p>}
            </div>
        )
    }
}